<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        title="KEEP IN TOUCH WITH US"
        pace="6"
      >
        <!--我司是一个致力于韩国电商服务的专业化物流公司-->
        <!--LTL国际物流有限公司，以中国威海对韩国的物流体系为基础，已成功打造高效电商物流全程线上服务系统。我们自主研发的ERP线上办公系统，将为您提供高效、专业的一站式到货服务。现有中国配送仓、中国港口仓、韩国仓，总面积达5000平（平方米换算），不仅保障时效性，而且能满足电商客户的一切需求。现代化的物流打包、分拣系统减少了人工失误所带来的损失。-->
        <!--公司创立伊始，就以服务电商的清晰发展理念为基础，在物流渠道的搭建及自主研发的跨境全物流追踪系统上，每一个细节都以服务跨境电商客户为出发点，努力打造一整套集物流的高速时效性、降低人工成本、简化办公流程、客户订单准确到达的跨境物流服务系统。-->
        <!--自主研发的ERP办公系统，已成功对接韩国6大主流电商平台，从单个订单收集发货到仓储库存发货服务、从产品批量收集修改到精修图软件支持、从以保障时效性的空运、海运多港口到达选择和成熟的小批量企业通关走货模式。每一个细节都使客户的需求在ERP内得到简化、支持和自主多样选择。-->
        <!--最高的时效，Ⅰ最低的成本，Ⅱ 排除了人工失误率，Ⅲ 成为轻松的平台卖家。-->
        LTL은 중국제품구매대행 사업자님들을 위한 종합 서비스 플랫폼입니다.
        소싱,구매, 물류대행 서비스를 기반으로 한 상품아이입니다. 상품주문, 주문번호수집운송장 운송장 업로드 가능 합니다.
        현재 글로벌셀러를 위한 대량등록 솔루션,배송대행서비스 가장 뛰어나고 가장 편하다고 자부합니다.
        글로벌셀러 사업자님은 상품아이템만 찾고 판매에만 집중 하도록 도와 드립니다. 그이외에 엘티엘에 도와드리겠습니다.
      </base-info-card>

      <!--<base-business-contact dense />-->
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessInfo',
    props: { dark: Boolean },
    data: () => ({
    })
  }
</script>
